import * as httpHelper from "../../utils/http-helper";

function buscarDadosIniciais(cooperadoID: string | number) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ProcedimentoCooperado/DadosIniciais/${cooperadoID}`
  );
}

function buscarProcedimentos(contratoID: string | number) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.get(
    headers,
    `ProcedimentoCooperado/GetProcedimentos/${contratoID}`
  );
}

function buscarProcedimentosCooperado(
  contratoID: string | number,
  competencia: number,
  cooperadoID: string | number
) {
  const headers = httpHelper.defaultHeaders();
  const filtros = { contratoID, competencia, cooperadoID };

  return httpHelper.post(headers, filtros, `ProcedimentoCooperado/Listar`);
}
function criarProcedimentoCooperado(form: Record<string, any>) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.post(headers, form, `ProcedimentoCooperado/Post`);
}
function removerProcedimentoCooperado(procedimentoID: string | number) {
  const headers = httpHelper.defaultHeaders();

  return httpHelper.remove(
    headers,
    {},
    `ProcedimentoCooperado/Delete/${procedimentoID}`
  );
}

const procedimentosService = {
  buscarDadosIniciais,
  buscarProcedimentos,
  buscarProcedimentosCooperado,
  criarProcedimentoCooperado,
  removerProcedimentoCooperado,
};

export default procedimentosService;
